module.exports = __webpack_public_path__ + "img/bg-matthew-cunningham.dd6a8e05.jpg";